import { render, staticRenderFns } from "./MomentoContable.vue?vue&type=template&id=eaa6cbec&"
import script from "./MomentoContable.vue?vue&type=script&lang=js&"
export * from "./MomentoContable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports